import { render, staticRenderFns } from "./participation_card.vue?vue&type=template&id=1bd00fed&scoped=true"
import script from "./participation_card.vue?vue&type=script&lang=js"
export * from "./participation_card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd00fed",
  null
  
)

export default component.exports